module.exports = __webpack_public_path__ + "static/media/clock.380b95e8.svg";